<template lang='pug'>
  v-flex(
    v-if='componentFormated.key && !componentFormated.hidden && containsLikeKey(resultForms, componentFormated.key)'
    :class='divMainClass'
  )
    div(v-if='componentFormated.type === "panel"')
      .body-2.font-weight-bold.mt-1.mb-3 {{ componentFormated.label }}
      v-layout(row, wrap)
        template(
          v-for='(item, index) in componentFormated.components'
        )
          summary-field(
            :component='item'
            :formKey='`${formKey}.${item.key}`'
            :formKeyRecursiveNum='formKeyRecursiveNum'
            :result-forms='resultForms'
            :key='componentFormated.key + index'
            )
    div(v-else-if='componentFormated.type === "tab"')
      v-layout(row, wrap)
      template(
        v-for='num in parseInt(formVal)'
        v-if='containsValueRecursive(`${formKey}.${componentFormated.components[0].key}`, num)'
      )
        v-flex(xs12 v-if="num > 1")
          v-divider
        summary-field(
          :component='componentFormated.components[0]'
          :formKey='`${formKey}${formKey.indexOf(componentFormated.key) > -1 ? "" : "." + componentFormated.key}`'
          :formKeyRecursiveNum='formKeyRecursiveNum ? [...formKeyRecursiveNum, num] : createArrayFromNumber(num)'
          :result-forms='resultForms'
          :key='componentFormated.components[0].key + num'
        )
    div(v-else-if='componentFormated.type === "tabItem"')
      .body-2.font-weight-bold.mt-1.mb-3 {{ componentFormated.label }} {{ formKeyRecursiveNum[formKeyRecursiveNum.length - 1] }}
      v-layout(row, wrap)
        template(v-for='(item, index)  in componentFormated.components')
          summary-field(
            :component='item'
            :formKey='`${formKey}.${componentFormated.key}`'
            :formKeyRecursiveNum='formKeyRecursiveNum'
            :result-forms='resultForms'
            :key='item.key + index'
          )
    div(v-else)
      v-layout(row, wrap)
        template(v-if="componentFormated.type === 'richtexteditor'")
          v-flex(xs12)
            u-field-btn-print(v-model='noPrint', :label='componentFormated.label' :label-no-print="true" @change='onChangeNoPrint')
            span(v-html='formVal')
        template(v-else-if="componentFormated.type === 'evolutionchart'")
          v-flex.zoom-0(xs12 v-show='resultForms[formKey]')
            u-field-btn-print(v-model='noPrint', :label='componentFormated.label' :label-no-print="true" @change='onChangeNoPrint')
            .pt-2
              v-layout(row, wrap)
                u-evolution-chart(:id='formKey' :component="componentFormated", v-model='resultForms[formKey]' :values="resultForms", :print='true')
        template(v-else-if="componentFormated.type === 'table'")
          v-flex.zoom-0(xs12)
            .pt-2
              v-layout(row, wrap)
                u-field-component-table(:component="componentFormated", :formKeyRecursiveNum='[formKeyRecursiveNum[formKeyRecursiveNum.length - 1]]', :formKey="formKey" :values="resultForms")
        template(v-else-if="componentFormated.type === 'label'")
          v-flex(xs12)
            u-field-btn-print.pt-3(v-model='noPrint', :label='componentFormated.label' @change='onChangeNoPrint' :colon="false")
        template(v-else)
          v-flex(xs4)
            u-field-btn-print(v-model='noPrint', :label='componentFormated.label' @change='onChangeNoPrint')
          v-flex(xs8)
            div
              template(v-if="componentFormated.type === 'chartline'")
                u-chart-line(v-model='formVal' :chartData='formVal', :resultForm="resultForms", :component="componentFormated", :readonly='true', :print='true')
              template(v-else-if="componentFormated.type === 'datepicker'") {{ formVal | formatDateExtend }}
                span(v-if="componentFormated.key === 'birthdate'")  ({{ formVal | ageFriendly }})
              template(v-else) {{ `${formVal} ${componentFormated.suffix || ''}` }}
</template>

<script>
import _ from 'lodash'

import UFieldComponentTable from './FieldComponentTable'
import UFieldBtnPrint from './FieldBtnPrint'
import UChartLine from '@/components/form/inputs/ChartLine'
import UEvolutionChart from '@/components/charts/EvolutionChart'

export default {
  name: 'summary-field',

  components: {
    UFieldComponentTable,
    UFieldBtnPrint,
    UChartLine,
    UEvolutionChart
  },

  props: {
    component: {
      type: Object
    },
    resultForms: {
      type: Object
    },
    resultFormJSON: {
      type: Boolean
    },
    formKey: {
      type: String
    },
    formKeyRecursiveNum: {
      type: Array
    }
  },

  computed: {
    formVal: {
      get () {
        let KEY = this.formKey

        if (this.formKeyRecursiveNum) {
          // this.formKeyRecursiveNum.forEach(item => {
          //   KEY = KEY.replace('$', '_' + item)
          // })
          KEY = KEY.replace('$', '_' + this.formKeyRecursiveNum[this.formKeyRecursiveNum.length - 1])
          KEY = `${KEY}.${this.component.key}`
        }

        let val = this.resultFormJSON ? _.get(this.resultForms, this.formKey) : this.resultForms[KEY]
        if (!val) return null
        if (typeof val === 'object') {
          if (!(val.percentil || !_.isEmpty(val.result) || !_.isEmpty(val.rows))) return null
          if (this.component.type === 'textfield') val = val.result
        }

        if (this.component.filter) {
          val = this.f(val, this.component.filter)
        } else if (this.component.mask) {
          val = this.m(val, this.component.mask)
        }

        return val
      },
      set () {
        console.log('SET -> ' + this.formKey)
      }
    },

    componentFormated () {
      if (!this.component) return {}

      let comp = _.cloneDeep(this.component)
      if (comp.type === 'evolutionchart') {
        comp.style = 'xs12'
        comp.noLabel = true
      }

      return comp
    },

    divMainClass () {
      const componentStyle = this.componentFormated.printStyle || this.componentFormated.style
      let classe = {
        'no-print not-print': this.noPrint
      }
      classe[componentStyle] = true

      return classe
    }
  },

  data () {
    return {
      msg: 'summary-field',
      noPrint: false
    }
  },

  created () {
    if (this.component.type === 'evolutionchart') this.noPrint = true
  },

  mounted () {
    setTimeout(() => {
      this.refreshNoPrint()
    }, 500)
  },

  methods: {
    containsLikeKey (obj, key) {
      if (this.resultFormJSON) {
        return _.has(this.resultForms, this.formKey) && [undefined, null, ''].indexOf(_.get(this.resultForms, this.formKey)) < 0
      }

      const keySplit = this.formKey.split('.')
      let KEY
      if (keySplit[keySplit.length - 1] === key) {
        KEY = this.formKey
      } else {
        KEY = this.formKey + '.' + key
        KEY = KEY.replace(/\./g, '\\.').replace(/\$/g, '_[0-9]')
        if (['tabItem', 'table'].indexOf(this.component.type) < 0) KEY += '$'
      }
      const listMatched = Object.keys(obj).filter(item => {
        if (item.endsWith('.fetos') || item.endsWith('.sacos')) return false
        let val = obj[item]
        if (!val) return false
        if (typeof val === 'object' && !(val.percentil || !_.isEmpty(val.result))) {
          return false
        }
        // return item.indexOf(KEY) === 0
        return item.match(KEY)
      })
      // console.log('KEY: ' + KEY, listMatched)
      if (listMatched.length > 0) {
        // console.log(listMatched[0], this.resultForms[listMatched[0]])
        return true
      } else return false
    },
    containsValueRecursive (key, recursive) {
      const KEY = key.replace('$', '_' + recursive)
      return Object.entries(this.resultForms).filter(([key]) => key.indexOf(KEY) > -1).length > 0
    },
    onChangeNoPrint () {
      let printItems = localStorage.getItem('print-items')
      if (!printItems) printItems = {}
      else printItems = JSON.parse(printItems)
      printItems[this.formKey] = this.noPrint
      localStorage.setItem('print-items', JSON.stringify(printItems))
    },
    refreshNoPrint () {
      let printItems = localStorage.getItem('print-items')
      if (!printItems) return
      else printItems = JSON.parse(printItems)
      const printItem = printItems[this.formKey]
      if (printItem !== undefined) this.noPrint = printItem
    },
    createArrayFromNumber (payload) {
      let data = []
      let length = parseInt(payload)
      for (let i = 1; i <= length; i++) {
        data.push(i)
      }
      return data
    }
  }
}
</script>

<style lang='stylus' scoped>
  .checkbox-print
    position absolute
    left 0px
  .not-print
    opacity 0.3
  .zoom-0
    zoom 1!important
  div >>> .flex
    padding-top 2px!important
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/components/Field.vue